import { render, staticRenderFns } from "./PageLinkButton.vue?vue&type=template&id=f7e5944a&scoped=true&lang=pug&"
import script from "./PageLinkButton.vue?vue&type=script&lang=ts&"
export * from "./PageLinkButton.vue?vue&type=script&lang=ts&"
import style0 from "./PageLinkButton.vue?vue&type=style&index=0&id=f7e5944a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e5944a",
  null
  
)

export default component.exports